import { useAppStore } from "./app.store";
import type { DatabaseCreationInfo } from "./store-types";

export function useAuthenticatedUser() {
  const authUser = useAppStore((state) => state.authUser);
  if (!authUser) throw new Error("No authenticated user");
  return authUser;
}

export function useRefreshReferencesNReferenceData(referenceId: number) {
  const setReferences = useAppStore((state) => state.setGeneratedReferences);
  const referenceDataById = useAppStore((state) => state.referenceDataById);
  const setReferenceDataById = useAppStore((state) => state.setReferenceDataById);

  return () => {
    const oldReferenceDataById = new Map(referenceDataById);
    oldReferenceDataById.set(referenceId, undefined);
    setReferenceDataById(oldReferenceDataById);
    setReferences(undefined);
  };
}

export function useGetDatabaseCreationInfo() {
  const stateDatabaseCreationInfo = useAppStore((state) => state.databaseCreationInfo);
  const setStateDatabaseCreationInfo = useAppStore((state) => state.setDatabaseCreationInfo);

  const getDatabaseCreationInfo = (): DatabaseCreationInfo | undefined => {
    if (stateDatabaseCreationInfo) return stateDatabaseCreationInfo;
    return;
  };

  const setDatabaseCreationInfo = (data: DatabaseCreationInfo) => {
    setStateDatabaseCreationInfo(data);
  };

  const clearDatabaseCreationInfo = () => {
    setStateDatabaseCreationInfo(undefined);
  };

  return { getDatabaseCreationInfo, setDatabaseCreationInfo, clearDatabaseCreationInfo };
}
